import { type ICellEditorParams } from "ag-grid-community";
import { type FC } from "react";
import { type FileDefinitionType, isFilenameOfType } from "widgets/utils";

import { FilePickerControlledDialog } from "@/modules/files/components/FilePickerControlledDialog.tsx";
import { isFileOfType, sortProjectFileByFileName } from "@/modules/files/utils/file.ts";

import { type FileType } from "../../../../../graphql.ts";
import { ATTRIBUTE_FILE_TYPES } from "../../../../../settings/settings.ts";
import { type IAgGridCellProps } from "../../cell-base-interfaces.ts";
import { type CellEditorParams } from "../../cell-editor-factory.tsx";
import FileCell from "../core/FileCell.tsx";
import { TableCell } from "../core/TableCell.tsx";

export const EditableFileCell: FC<IAgGridCellProps> = (props) => {
  return (
    <FileCell
      {...props}
      triggerButtonProps={{
        label: "Browse Files",
        //intent: TriggerButtonIntent.Active,
        icon: "folder_open",
        onPress: () => props.api.startEditingCell({ rowIndex: props.rowIndex, colKey: props.column }),
      }}
    />
  );
};

export const FileCellEditor: FC<ICellEditorParams & CellEditorParams> = (params) => {
  const { value, fileType } = params;

  const fileFilterTypes = getFilePickerFilterExtensions(fileType);
  return (
    <TableCell>
      <FilePickerControlledDialog
        isSelectableFilter={
          fileType?.id === ATTRIBUTE_FILE_TYPES.ANY
            ? () => true
            : (file) => {
                const filename = file.fileName ?? file.fullPath;
                return isFileOfType(fileFilterTypes)({ ...file, fileName: filename });
              }
        }
        baseFilterHint={
          fileFilterTypes
            ? `Files of type ${fileFilterTypes.join(", ")} can be selected.`
            : "Any file or folder can be selected"
        }
        fileDefinitionTypes={fileFilterTypes}
        onValid={(files) => {
          const sortedFiles = sortProjectFileByFileName(files);
          const done = params.node.setDataValue(params.column, sortedFiles);
          return done ? Promise.resolve() : Promise.reject();
        }}
        isOpen
        onClose={() => params.api.stopEditing()}
      />
    </TableCell>
  );
};

function getFilePickerFilterExtensions(fileType: FileType): FileDefinitionType[] | null {
  const attributeFileType = fileType?.id;

  if (attributeFileType === ATTRIBUTE_FILE_TYPES.UNALIGNED_READ_DATA) {
    return ["FASTQ"];
  } else if (attributeFileType === ATTRIBUTE_FILE_TYPES.ALIGNED_READ_DATA) {
    return ["BAM", "SAM"];
  }

  return null;
}
